import {useLocalStorage} from '@github-ui/use-safe-storage/local-storage'

/**
 * Persisted collapse state for a single review thread, keyed by `threadId`.
 *
 * All review-thread surfaces (file-level, inline, conversation header,
 * placeholder/without-data) call this hook so they share the same storage key
 * and stay in sync via `useLocalStorage`'s in-memory cache + per-key pub/sub.
 *
 * Pass the default the caller expects when nothing is stored — typically
 * `thread.isResolved ?? false`.
 */
export function useReviewThreadCollapseState(
  threadId: string,
  defaultCollapsed: boolean,
): ReturnType<typeof useLocalStorage<boolean>> {
  return useLocalStorage<boolean>(`reviewThreadIsCollapsed_${threadId}`, defaultCollapsed)
}
